import { useEffect } from "react";
import "./assesment.scss";

const Header = (props) => {
  return (
    <div className="aiInterview_header">
        <div className="flex items-center justify-between">
          <div>
            <span className="ai_left_header">Candidate Name : </span>
            <span className="ai_right_header">
              {props.data && props.data.candidate}
            </span>
          </div>
          <h3>
            <span className="ai_interview_details">
              Request Date: {props.data && props.data.created_date_formatted} |
              Attended Date {props.data && props.data.interview_attended_date}
            </span>
          </h3>
      </div>
    </div>
  );
};

export default Header;
